import {useContext, useEffect, useState} from "react";
import {MapContainer, Marker, Popup, TileLayer, useMapEvents} from "react-leaflet";

import MapResizeZoom from "components/maps/MapResizeZoom";
import {MarkerIcon} from "components/waste-icons";
import AuthContext from "context/AuthContext";
import {CARTO_TILE_URL, CARTO_TILE_OPTIONS} from 'core/mapsConfig';

const MapPointOnClick = ({center, onMapClick}) => {
    const {panel} = useContext(AuthContext);
    const [zoom, setZoom] = useState(13);
    const [position, setPosition] = useState(center);

    useEffect(() => {
        center.length && center[0] && center[1]
            ? setPosition(center)
            : setPosition(panel.coords);
    }, [center]);

    const MapClickHandler = () => {
        useMapEvents({
            click(event) {
                // onMapClick(event.latlng);
            },
            zoomend(event) {
                const newZoom = event.target.getZoom();
                setZoom(newZoom);
            },
        });
        return null;
    };

    return position.length ? (
        <MapContainer
            id={Math.random().toString(36).substring(2, 18)}
            center={position}
            zoom={zoom}
            scrollWheelZoom={true}
            style={{width: "100%", height: "300px", zIndex: "2"}}>
            {position.length && position[0] && position[1] ? (
                <MapResizeZoom position={position} zoomDefault={zoom} />
            ) : (
                <></>
            )}

            <TileLayer
                url={CARTO_TILE_URL}
                {...CARTO_TILE_OPTIONS}
            />
            <Marker position={position} icon={MarkerIcon}>
                <Popup>
                    <div>
                        <p>
                            Coordenadas: {position[0]}, {position[1]}
                        </p>
                    </div>
                </Popup>
            </Marker>
            <MapClickHandler />
        </MapContainer>
    ) : (
        <></>
    );
};

export default MapPointOnClick;
